"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useLanguage = void 0;
var _react = require("react");
var _translationsContext = require("../translationsContext");
/**
 * Custom hook for accessing current language provided to TranslationsProvider.
 *
 * @returns Language which contains translations and related information.
 */ var useLanguage = function() {
    var _ref = (0, _react.useContext)(_translationsContext.translationsContext), currentLanguage = _ref.currentLanguage, language = _ref.language;
    return (0, _react.useMemo)(function() {
        var _ref;
        return {
            language: (_ref = language !== null && language !== void 0 ? language : currentLanguage) !== null && _ref !== void 0 ? _ref : ''
        };
    }, [
        language,
        currentLanguage
    ]);
};
exports.useLanguage = useLanguage; //# sourceMappingURL=useLanguage.js.map
